module.exports = __webpack_public_path__ + "img/one-star.edc15951.svg";